import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Typography } from 'foundations-library/components'

const useStyles = makeStyles(theme => ({
    sidebarV2Link: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '8px 0',
        rowGap: '4px',
        textAlign: 'center',
        position: 'relative',
        cursor: 'pointer',
        overflow: 'hidden',
        '& .badge': {
            position: 'absolute',
            top: '0px',
            right: '10px'
        },
        '& svg path': {
            fill: '#A6A6A6 !important'
        },
        '&:hover:not(.active)': {
            '& svg path': {
                fill: '#fff !important'
            },
            '& $title': {
                color: '#fff'
            }
        },
        '&.active': {
            '& svg path': {
                fill: `${theme.palette.primary['+300']} !important`
            },
            '& $title': {
                color: theme.palette.primary['+300']
            }
        },
        borderRadius: ({ animate }: { animate: boolean }) => animate ? '10px 10px 0 0' : 'initial',
        backgroundImage: ({ animate }: { animate: boolean }) => animate ? 'radial-gradient(circle, #ffce80, #f38c00)' : 'initial',
        '&::before': {
            content: ({ animate }: { animate: boolean }) => animate ? '""' : 'none',
            position: 'absolute',
            width: '150%',
            height: '10px',
            backgroundColor: 'rgba(255,255,255,.2)',
            filter: 'blur(4px)',
            transform: 'rotate(135deg) translateX(20px)',
            animation: '$crossfade 2s infinite'
        }
    },
    '@keyframes crossfade': {
        '0%': {
            top: '-50px',
            left: '-50px'
        },
        '100%': {
            top: '50px',
            left: '50px'
        }
    }
}))

interface props {
    active?: boolean;
    icon: React.ReactNode;
    title?: string;
    badge?: React.ReactNode;
    animate?: boolean;
    onClick?: () => void;
}

/**
 * This defines the style and structure common to ALL items along SidebarV2.
 */
const SidebarV2Link = ({ active, icon, title, badge, animate, onClick }: props) => {
    const classes = useStyles({ animate })

    return (
        <div className={`${classes.sidebarV2Link} ${active ? 'active' : ''}`} onClick={onClick}>
            {icon}

            {title &&
                <Typography variant='captionHeavy' color={!animate ? 'neutral-100' : 'neutral-800'}>
                    {title}
                </Typography>
            }

            {badge}
        </div>
    )
}

export default SidebarV2Link
